import { createGetCurrentHistoryStackEntrySelector } from '../history-stack';
import { getAdminModals } from './get-admin-modals';

export const getCurrentAdminModal = createGetCurrentHistoryStackEntrySelector(
  getAdminModals,
);
